export default __webpack_public_path__ + "static/media/logo.ec4399c6.svg";